import { z, ZodType } from 'zod'

import { emptySelectOptionZod, selectOptionZod } from 'components/Select'
import { domainBidderPriorities } from 'features/globalSetup/types/bidderPriority'
import { Domain } from 'features/inventory/types/domain'
import { MAX_SAFE_GQL_INTEGER } from 'providers/graphql/constants'

type DomainBidderSlice = { domain: Pick<Domain, 'id'> }

const CONSTANTS = {
  AD_UNIT_BIDDER_PARAM: {
    NAME: z.string(),
    VALUE: z.string().or(z.number().max(MAX_SAFE_GQL_INTEGER)).nullable(),
  },
  ID: z.string(),
} as const

const domainIds = z.object({
  domainBidderId: selectOptionZod<DomainBidderSlice>(),
  domainId: CONSTANTS.ID,
})

const adUnitBidderParams = z.record(
  CONSTANTS.AD_UNIT_BIDDER_PARAM.NAME,
  CONSTANTS.AD_UNIT_BIDDER_PARAM.VALUE,
)
export type SchemaAdUnitBidderParams = z.infer<typeof adUnitBidderParams>

export const csEnabled: ZodType<boolean> = z.boolean()
export const s2sEnabled: ZodType<boolean> = z.boolean()
export const priority = z.enum(domainBidderPriorities)

export const adUnitBidderProps = z.object({
  csDisabledByRequiredParams: z.boolean(),
  csEnabled,
  csParams: adUnitBidderParams,
  s2sDisabledByRequiredParams: z.boolean(),
  s2sEnabled,
  s2sParams: adUnitBidderParams,
})
export type SchemaAdUnitBidderProps = z.infer<typeof adUnitBidderProps>

export const schema = z.object({
  adUnitBidders: z.record(CONSTANTS.ID, adUnitBidderProps),
  csEnabled,
  domainIds: domainIds,
  priority,
  s2sEnabled,
})
export type Schema = z.infer<typeof schema>

export const defaults: Schema = {
  adUnitBidders: {},
  csEnabled: false,
  domainIds: {
    domainBidderId: emptySelectOptionZod<DomainBidderSlice>(),
    domainId: '',
  },
  priority: 'primary',
  s2sEnabled: false,
} as const
